var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 82,
    viewBox: "0 0 67 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9404 12.8378C44.0378 18.0578 46.8204 27.8292 47.0543 39.3889H61.9999C61.2902 26.5 52.1115 15.8344 39.9404 12.8378Z",
    fill: "#00A100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9404 69.1622C52.1115 66.1736 61.2821 55.508 61.9999 42.6111H47.0543C46.8204 54.1628 44.0378 63.9422 39.9404 69.1622Z",
    fill: "#00A100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1797 42.6111C22.5104 55.8866 26.8578 70 32.9957 70C39.1337 70 43.481 55.8866 43.8117 42.6111H22.1797Z",
    fill: "#00A100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0595 12.8378C13.8885 15.8264 4.71784 26.4919 4 39.3889H18.9456C19.1795 27.8372 21.9622 18.0578 26.0595 12.8378Z",
    fill: "#00A100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1797 39.3889H43.8117C43.481 26.1133 39.1337 12 32.9957 12C26.8578 12 22.5104 26.1133 22.1797 39.3889Z",
    fill: "#00A100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00781 42.6111C4.71759 55.5 13.8963 66.1655 26.0673 69.1622C21.97 63.9422 19.1873 54.1708 18.9534 42.6111H4.00781Z",
    fill: "#00A100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThird);
export default __webpack_public_path__ + "static/media/third.94cbc90f7d3e6b50523273c850d1653f.svg";
export { ForwardRef as ReactComponent };